module.exports = __webpack_public_path__ + "static/media/1029617.755e8dd5.jpg";